export enum ColorIntensity{
    NONE= -1,
    LOW= 0,
    MEDIUM= 1,
    HIGH= 2,
    HIGHER= 3,
}
